import { createGlobalStyle } from 'styled-components';
import { theme, palette } from 'styled-tools';

/**
 * @see {@link http://meyerweb.com/eric/tools/css/reset/}
 * v2.0 | 20110126
 * License: none (public domain)
 * */

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    font: inherit;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  body {
    font-family: ${theme('fontFamily')};
    font-size: ${theme('fontSize.sm')};
    color: ${palette('textContrast1')};
    background-color: ${palette('bgBody')};
  }

  a {
    color: ${palette('textLink')};
  }

  button, input, textarea {
    font-family: ${theme('fontFamily')};
  }

  p {
    line-height: 1.5;
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .tooltip {
    max-width: 150px !important;
    line-height: 1.5 !important;
    font-size: ${theme('fontSize.xxs')} !important;
  }

  ${theme('components.globalStyle')}
`;

export default GlobalStyle;
